import { DatiqGraphCardChartSchema } from '@dat/datiq-components-pkg/graph-card';
import { z } from 'zod';

export const DatiqCellGraphValueSchema = z.object({
    chart: DatiqGraphCardChartSchema,
});

export interface IDatiqCellGraphValue
    extends z.infer<typeof DatiqCellGraphValueSchema> {}
  